import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const tableColumns = [
        {
            label: "学年",
            prop: "year",
            align: "center",
            show: true
        },
        {
            label: "学期",
            prop: "semester",
            align: "center",
            show: true
        },
        {
            label: "学年学期号",
            prop: "yearSemesterNo",
            align: "center",
            show: true
        },

        {
            label: "开始时间",
            prop: "startDate",
            align: "center",
            show: true
        },
        {
            label: "结束时间",
            prop: "endDate",
            align: "center",
            show: true
        },
        {
            label: "开始周次",
            prop: "startWeek",
            align: "center",
            show: true
        },
        {
            label: "结束周次",
            prop: "endWeek",
            align: "center",
            show: true
        },
        {
            label: "是否当前学年学期",
            name: 'status',
            align: "center",
            show: true
        },
        {
            label: "备注",
            prop: "remark",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: 'custom',
            align: "center",
            show: true
        },
    ]

    const formItems = [
        {
            label: "学年",
            span: 24,
            type: 'year',
            placeholder: '请选择',
            model: "year",
        },
        {
            label: "学期",
            span: 24,
            type: 'number',
            placeholder: '请输入',
            model: "semester",
        },
        {
            label: "开始时间",
            span: 24,
            type: 'date',
            placeholder: '请选择',
            model: "startDate",
            pickerOptions: {
                disabledDate(time) {
                    // console.log(time)
                    if (that.handleData.endDate) {
                        let time1 = new Date(that.handleData.endDate);
                        return time.getTime() > time1.getTime()
                    }
                }
            },
        },
        {
            label: "结束时间",
            span: 24,
            type: 'date',
            placeholder: '请选择',
            model: "endDate",
            pickerOptions: {
                disabledDate(time) {
                    // console.log(time)
                    let oneDay = 24 * 60 * 60 * 1000;
                    let time1 = new Date(that.handleData.startDate).getTime() - oneDay;
                    return time.getTime() <= time1
                }
            },
        },
        {
            label: "开始周次",
            span: 24,
            placeholder: '请输入',
            model: "startWeek",
        },
        {
            label: "结束周次",
            span: 24,
            placeholder: '请输入',
            model: "endWeek",
        },
        {
            label: "是否当前学年学期",
            span: 24,
            type: 'radio',
            placeholder: '请选择',
            model: "isCurrent",
            options: dic._IS,
        },
        {
            label: "备注",
            span: 24,
            type: 'textarea',
            placeholder: '请输入',
            model: "remark",
        },
    ]
    const formRules = {
        year: [{
            required: true,
            message: "请选择",
            trigger: "blur"
        }],
        semester: [{
            required: true,
            message: "请输入",
            trigger: "blur"
        }],
        startDate: [{
            required: true,
            message: "请选择",
            trigger: "blur"
        }],
        endDate: [{
            required: true,
            message: "请选择",
            trigger: "blur"
        }],
        startWeek: [{
            required: true,
            message: "请输入",
            trigger: "blur"
        }],
        endWeek: [{
            required: true,
            message: "请输入",
            trigger: "blur"
        }],
        isCurrent: [{
            required: true,
            message: "请选择",
            trigger: "blur"
        }],
        remark: [{
            required: true,
            message: "请输入",
            trigger: "blur"
        }],
    }
    return {
        formItems,
        formRules,
        tableColumns,
    }
}